import React, { useState } from "react";
import "../../design/service.css";
import { Container } from "react-bootstrap";
import { skillTreeData } from "../../helper/serviceCardInfoArray";
import { goToLinkWithNewTab } from "../../helper/changeLocation";

export default function Service() {
    const [activeSkill, setActiveSkill] = useState(skillTreeData[1].skills[0]);

    return (
        <section id="services" className="serviceSection">
            <Container>
                {/* Header */}
                <div className="cyberSectionHeader">
                    <span className="sectionTag">SYSTEM ARCHITECTURE</span>
                    <h2>TECHNICAL <span className="gradientText">SKILL TREE</span></h2>
                    <p className="sectionSub">Interactive engineering branch capabilities</p>
                </div>

                {/* Tree Layout Container */}
                <div className="treeWrapper">
                    {/* Central Vertical Trunk Connection */}
                    <div className="treeTrunkLine" />

                    {skillTreeData.map((tier, tierIdx) => (
                        <div key={tierIdx} className="treeTierRow">
                            <div className="tierLabelBadge">
                                <span>{tier.tag}</span>
                                <h4>{tier.category}</h4>
                            </div>

                            <div className="tierNodesGrid">
                                {tier.skills.map((skill) => (
                                    <div
                                        key={skill.id}
                                        className={`treeNodeCard ${activeSkill?.id === skill.id ? "nodeSelected" : ""}`}
                                        onClick={() => setActiveSkill(skill)}
                                    >
                                        <div className="nodeIcon">{skill.icon}</div>
                                        <div className="nodeInfo">
                                            <h5>{skill.title}</h5>
                                            <span className="nodeClickText">Click to Expand</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Skill Detail Inspector Panel */}
                {activeSkill && (
                    <div className="treeInspectorPanel">
                        <div className="inspectorHeader">
                            <div className="inspectorIcon">{activeSkill.icon}</div>
                            <div>
                                <h3>{activeSkill.title}</h3>
                                <span className="inspectorTag">SPECIFICATION BREAKDOWN</span>
                            </div>
                        </div>

                        <p className="inspectorDesc">{activeSkill.desc}</p>

                        <div className="inspectorSpecsList">
                            {activeSkill.specs.map((spec, i) => (
                                <span key={i} className="specBadge">
                                    ✓ {spec}
                                </span>
                            ))}
                        </div>

                        <button
                            className="inspectorBtn"
                            onClick={() => goToLinkWithNewTab(activeSkill.link)}
                        >
                            EXPLORE SPECS & DETAILS
                        </button>
                    </div>
                )}
            </Container>
        </section>
    );
}